import { render, staticRenderFns } from "./alternating.vue?vue&type=template&id=183a1d8e&scoped=true&"
import script from "./alternating.vue?vue&type=script&lang=js&"
export * from "./alternating.vue?vue&type=script&lang=js&"
import style0 from "./alternating.vue?vue&type=style&index=0&id=183a1d8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a1d8e",
  null
  
)

export default component.exports